import moment from 'moment';
// import config from '../config';
import searchRecommendApi from './api/searchRecommendApi';
/* ACTIONS */
// export const OPENSEARCH_TOP10MOVIETITLELIST = 'OPENSEARCH/TOP10MOVIETITLELIST';


/* ROUTE API */
// const SPICONFIG_LIST_ROUTE = '/broadcast';

const initialState = {
};


export default (state = initialState, action) => {
	switch (action.type) {
		// case SPICONFIG_LIST:
		// 	return {
		// 		...state,
		// 		spiconfigList: action.payload,
		// 	};
		default:
			return state;
	}
};

export const datagramGet = ({text, env}) => {
	return dispatch => {
		return searchRecommendApi.get(`/datagram/search?search=${text}&env=${env}&showAll=true`).then(data => {
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};